import React from "react";
import { UserManagement, USER_TYPES } from "../../modules/user-management";

const SystemUsers = () => {
  return <UserManagement userType={USER_TYPES.SYSTEM} />;
};

export default SystemUsers;
